export default __webpack_public_path__ + "static/media/product-workspace-logo.41d1b5aa.svg";